/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_FontInputs */

const en_mobile_player_font = /** @type {(inputs: Mobile_Player_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font`)
};

const es_mobile_player_font = /** @type {(inputs: Mobile_Player_FontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

/**
* | output |
* | --- |
* | "Font" |
*
* @param {Mobile_Player_FontInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_font = /** @type {((inputs?: Mobile_Player_FontInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_FontInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_font(inputs)
	return en_mobile_player_font(inputs)
});